import React, {useState} from 'react';
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import AttributeList from "../../subfeatures/attributes/components/AttributeList";
import styles from "./CatalogOutput.module.scss";
import ProductList from "../../subfeatures/products/components/ProductList";
import { useTranslation } from 'react-i18next';
import classNames from "classnames";
import {useAppSelector} from "../../../../app/store";
import {currentCompanyIdSelector, employeeDataSelector} from "../../../auth/reducer";
import {MenuModes} from "../../../profile/models";
import Button from "react-bootstrap/Button";
import {requestMenuSync} from "../../api";
import {useDispatch} from "react-redux";
import {addNotify} from "../../../../common/actions/notify";
import {getAxiosErrorMessage} from "../../../../common/utils/functions";

/**
 * Каталог продуктов и атрибутов
 */
const CatalogOutput: React.VFC = () => {

  const {t} = useTranslation('translation', {keyPrefix: 'features.catalog'});
  const dispatch = useDispatch();

  const companyId = useAppSelector(currentCompanyIdSelector);
  const {companies} = useAppSelector(employeeDataSelector) ?? {};
  const currentCompany = companies?.find(({id}) => id === companyId);
  const isPosMode = currentCompany?.menuMode === MenuModes.POS;

  const [syncLoading, setSyncLoading] = useState(false);

  const handleMenuSync = () => {
    if (!companyId) return;
    setSyncLoading(true);
    requestMenuSync(companyId)
      .catch((err) => {
        dispatch(addNotify(getAxiosErrorMessage(err)));
      })
      .finally(() => {
        setSyncLoading(false);
      });
  };

  const syncButton = isPosMode && (
    <Button
      variant="outline-primary"
      onClick={handleMenuSync}
      disabled={syncLoading}>
      {t('actionSyncMenu')}
    </Button>
  );

  return <div className="bg-white p-0 p-md-4 mb-5">
    {isPosMode && <div className={classNames(styles["sync-button-mobile"], "p-3 p-md-0 d-md-none")}>
      {syncButton}
    </div>}
    <div className={styles["tabs-wrapper"]}>
      <Tabs
        defaultActiveKey="products"
        id="menu-tabs"
        className={classNames(styles["custom-tabs"], "bg-white")}>
        <Tab eventKey="products" title={t(`products.items`)} className="p-3 p-md-0">
          <ProductList/>
        </Tab>
        <Tab eventKey="attributes" title={t(`attributes.items`)} className="p-3 p-md-0">
          <AttributeList/>
        </Tab>
      </Tabs>
      {isPosMode && <div className={classNames(styles["sync-button"], "d-none d-md-flex")}>
        {syncButton}
      </div>}
    </div>
  </div>;
}

export default CatalogOutput;
